import styled from 'styled-components';

interface PropsContent {
  active: boolean;
}

export const Body = styled.div`
  gap: 1rem;
  display: flex;

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 450px) {
    gap: 0.5rem;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background_white};
  width: 79%;
  padding-right: 1rem;

  .EnunciateAddCollaborator {
    display: flex;
    padding: 3rem 0 0 0;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.colors.tertiary_500};

    .searchExportContent {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .Icon {
        padding-right: 0.5rem;
      }
    }
    .TitlePage {
      font-size: 18px;
      font-weight: 300;
      margin: 0 0 10px 0;
    }
  }

  @media (max-width: 900px) {
    width: auto;
    margin-top: 0;
    padding: 0rem 1.5rem;

    .EnunciateAddCollaborator {
      padding: 0rem 1rem 0.5rem 1rem;
    }
  }

  @media (max-width: 545px) {
    padding: 0 1.5rem;

    .EnunciateAddCollaborator {
      flex-direction: column;
      padding: 0;

      .TitlePage {
        display: none;
      }

      .ImportDownloadList {
        flex-direction: column;
        width: 100%;
        gap: 0;
        padding: 0;

        button {
          padding: 0;

          svg {
            padding: 0.5rem;
          }
        }
      }
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div<PropsContent>`
  border-color: ${({ theme }) => theme.colors.primary}!important;

  .cntButtonAdd {
    display: flex;
    justify-content: flex-end;
    padding-top: 2rem;

    @media (max-width: 900px) {
      justify-content: center; 
      width: 100%;              
   }
  }

  .AddCheckedTypeProfile {
    align-items: center;
    color: ${({ theme }) => theme.colors.primary};
    margin-top: 1rem;

    .MuiTypography-root {
      font-family: 'Futura PT' !important;
      font-weight: 300;
    }

    .MuiCheckbox-root {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 400;
    }

    .Mui-checked {
      color: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .TypeProfile {
    display: flex;
    justify-content: space-between;
    gap: 1rem;

    div {
      display: flex;
      width: 100%;
      flex-direction: column;
    }

    .contentTypeOption {
      position: relative;
      margin: 0 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .contentOptionProfile {
        width: 95%;
        background-color: ${({ theme }) => theme.colors.background};
        display: ${({ active }) => (active ? 'flex' : 'none')};
        flex-direction: row;
        position: absolute;
        padding: 0.7rem;
        box-shadow: 0px 3px 6px #00000029;
        z-index: ${({ active }) => (active ? '10' : '0')};

        div:nth-child(1) {
          width: 50%;
          gap: 0.9rem;
          margin: 0;
          display: grid;
          padding: 0;
        }

        div:nth-child(2) {
          display: flex;
          flex-direction: column;
          padding: 0.5rem;
          width: 50%;
          gap: 0.9rem;
          display: flex;
          border-left: 1px Solid ${({ theme }) => theme.colors.text_gray};
          max-height: 4.5rem;
          overflow-y: auto;

          ::-webkit-scrollbar {
            width: 5px;
            background-color: ${({ theme }) => theme.colors.background_white};
          }

          ::-webkit-scrollbar:horizontal {
            height: 5px;
          }

          ::-webkit-scrollbar-track,
          ::-webkit-scrollbar-track-horizontal {
            border-radius: 10px;
          }

          ::-webkit-scrollbar-thumb,
          ::-webkit-scrollbar-thumb:horizontal {
            background-color: ${({ theme }) => theme.colors.tertiary_500};
            border-radius: 10px;
          }

          .selectedProfile {
            font-size: 14px;
            font-weight: 300;
            color: ${({ theme }) => theme.colors.text_gray};
            border: none !important;
          }
        }

        button {
          display: flex;
          justify-content: flex-start;
          height: 1rem;
          font-size: 14px;
          font-family: 'Futura PT' !important;
          border: none;
          padding: 0;
          outline: 0;
          background: none;
          transition: opacity 0.2s;

          &:hover,
          &:focus {
            opacity: 0.55;
            border-bottom: 1px solid;
          }
        }

        .buttonAdd {
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: ${({ theme }) => theme.colors.tertiary_500};
          font-weight: 300 !important;
          border-bottom: 1px solid;
          max-width: 5rem;

          svg {
            margin-left: 0.3rem;
          }
        }

        .buttonSelected {
          width: 21%;
          font-weight: 400 !important;
          color: ${({ theme }) => theme.colors.secondary};
        }
      }

      .inputIcon {
        display: flex;
        flex-direction: row;

        .svg {
          color: ${({ theme }) => theme.colors.primary};
          transition: 0.2s;
          margin-left: -1.3rem;
          align-self: center;
          transform: ${({ active }) => (active ? 'rotate(180deg)' : 'rotate(0deg)')};
        }

        .typeProfileOption {
          font-family: 'Futura PT';
          font-size: 22px;
          font-weight: 300;
          width: 100%;
          background-color: transparent;
          border: none;
          padding: 0 0.5rem;
          outline: none;
          border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
        }
      }

      .error {
        display: flex;
        flex-direction: row;
        gap: 0.2rem;
        align-items: center;
        color: red !important;
        gap: 0.2rem;

        svg {
          fill: ${({ theme }) => theme.colors.error} !important;
        }
      }
    }

    p {
      display: flex;
      align-items: center;
      font-weight: 300;
      font-size: 22px;
    }

    .contentDep {
      p {
        margin-right: 0.5rem;
      }
    }

    .divDropDownList {
      display: flex;
      align-items: center;
      flex-direction: column;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      svg {
        fill: ${({ theme }) => theme.colors.secondary};
      }

      .MuiButtonBase-root {
        font-family: 'Futura PT' !important;
      }

      .MuiInputBase-root {
        color: ${({ theme }) => theme.colors.primary}!important;
        border: none;
      }

      .MuiInputBase-root {
        font-family: 'Futura PT' !important;
        font-weight: 300;
      }

      .select-style {
        width: 100%;
        height: 1rem;
        padding: 0.5rem;
        font-size: 1rem;
        position: relative;
      }

      .MuiOutlinedInput-notchedOutline {
        border: none;
        border-bottom: 1px ${({ theme }) => theme.colors.text} solid;
        border-radius: unset;
      }

      .MuiMenuItem-root li {
        font-size: 1rem;
      }

      .teste {
        display: flex;
      }
    }
  }

  .AddCollaborators {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 1rem;
    padding: 2rem;
    min-height: 7.3rem;

    .InputNameEmail {
      border-color: ${({ theme }) => theme.colors.primary};
      display: flex;
      gap: 1.5rem;
      margin: auto;
      border-radius: 13px;
    }
  }

  @media (max-width: 450px) {
    .AddCollaborators .InputNameEmail {
      flex-direction: column;
    }

    .TypeProfile {
      flex-direction: column;
    }
  }

  @media (max-width: 320px) {
    .AddCollaborators {
      padding: 2rem 0.5rem;
    }
  }
`;

export const ContentSummary = styled.div`
  .SummaryEnunciate {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    p {
      margin-left: 0.3rem;
      font-size: 20px;
      align-items: center;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .divFiltrar {
      display: flex;
      align-items: flex-end;
      margin-left: 0.5rem;

      // div:nth-child(n){
      //   width: 100%;
      // }

      .MuiInputBase-root {
        color: ${({ theme }) => theme.colors.primary}!important;
      }

      .MuiInputBase-root {
        font-family: 'Futura PT' !important;
        font-weight: 300;
      }

      .MuiMenuItem-root li {
        font-size: 1rem;
      }
    }
  }

  .SummaryControllerCollaborators {
    display: flex;
    flex-wrap: wrap;
  }

  .InfoCollaborator {
    margin: 0.5em;
    width: 20rem;
    min-height: 7rem;
    background: ${({ theme }) => theme.colors.background};
    border-radius: 1rem;
    padding: 1rem 1rem 1rem 0.5rem;

    .NameCollaborator {
      font-weight: 450;
      color: ${({ theme }) => theme.colors.primary};
      font-size: 22px;
    }
  }

  .EnunciateSummaryCollaborator {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .IconsEdit {
      display: flex;
      justify-content: flex-end;

      .ButtonEditDelete {
        display: flex;
        border: none;
        outline: 0;
        background-color: none;
        transition: opacity 0.2s;

        &:hover,
        &:focus {
          opacity: 0.55;
        }
        svg{
          fill: ${({ theme }) => theme.colors.tertiary_500};
        }
      }
    }
  }

  .SummaryInfoCollaborators {
    font-weight: 300;
    display: flex;
    flex-direction: column;

    .cntInfoProfile {
      width: 100%;
      display: flex;
      margin: 0.5rem 0 0 0;
      align-items: center;
      gap: 0.5rem;

      p {
        display: flex;
        align-items: center;
        white-space: nowrap; 
        overflow: hidden;    
        text-overflow: ellipsis; 
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.secondary};
    
        span {
          display: inline-block;
          font-weight: 400;
          color: ${({ theme }) => theme.colors.primary};
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 8rem; 
          margin-left: 5px;
        }
      }
    }
  }

  .InfoTypeProfile {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .InfoEmailCollaborators {
    p {
      font-size: 22px;
      margin: none;
      padding: none;
      color: ${({ theme }) => theme.colors.text_gray};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (max-width: 672px) {
    .InfoCollaborator {
      width: 15rem;
    }
  }

  @media (max-width: 612px) {
    .SummaryEnunciate .divFiltrar {
      width: 100%;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 531px) {
    .InfoCollaborator {
      width: 90%;
    }
  }

  @media (max-width: 450px) {
  .cntInfoProfile p span {
    max-width: 6rem; 
  }
}


`;
